import React, { Component } from 'react';
import { createPortal } from 'react-dom';

import { arrayOf, bool, element, object, oneOf, oneOfType } from 'prop-types';

import { Alignment, Placement } from '@philips-emr/tws-constants';
import { DocumentContext } from '@philips-emr/tws-core/lib/component/context';
import { enumValues, getBestPosition, getPosition, onViewportScroll } from '@philips-emr/tws-utils';
import './position.scss';

class Position extends Component {

  static contextType = DocumentContext;

  static propTypes = {
    alignment: oneOf(enumValues(Alignment)),
    force: bool,
    children: oneOfType([element, arrayOf(element)]),
    matchTargetHeight: bool,
    matchTargetWidth: bool,
    placement: oneOf(enumValues(Placement)),
    target: oneOfType([element, object]),
    updateOnScroll: bool,
  };

  static defaultProps = {
    force: false,
    updateOnScroll: false,
  };

  state = {};

  contentRef = (contentElement) => {
    this.setState({ contentElement });
  };

  getBestPosition() {
    const { target, placement, alignment, force } = this.props;
    const { contentElement } = this.state;
    const { window } = this.context;

    const posFunction = force ? getPosition : getBestPosition;

    return posFunction({
      alignment,
      guestElement: contentElement,
      hostElement: target,
      placement,
      window,
    });
  }

  getStyle() {
    const { target, matchTargetWidth, matchTargetHeight } = this.props;

    const height = matchTargetHeight ? target.clientHeight : undefined;
    const width = matchTargetWidth ? target.clientWidth : undefined;

    const { guest } = this.getBestPosition();

    return {
      height,
      width,
      ...guest,
    };
  }

  updatePosition = () => {
    const { contentElement } = this.state;

    const { guest = {} } = this.getBestPosition();

    contentElement.style.top = `${guest.top}px`;
    contentElement.style.left = `${guest.left}px`;
  };

  componentDidMount() {
    const { updateOnScroll } = this.props;

    if (updateOnScroll) {
      this.unlisten = onViewportScroll(() => {
        window.requestAnimationFrame(this.updatePosition);
      });
    }
  }

  componentWillUnmount() {
    this.unlisten && this.unlisten();
  }

  renderContent() {
    const { children } = this.props;

    return (
      <div className="c-position" ref={this.contentRef} style={this.getStyle()}>
        {children}
      </div>
    );
  }

  render() {
    if (!this.props.target) {
      return null;
    }

    return createPortal(this.renderContent(), this.context.document.body);
  }
}

export default Position;
